import { FormRadioButton, FormRadioGroup } from "@jsq/ds/forms";
import type { FieldDataType } from "~/graphql/supergraphTypes";

const NODE_COMPONENT_FIELD_TYPE_OPTIONS: ReadonlyArray<{
  value: FieldDataType;
  label: string;
}> = [
  { value: "VALUE", label: "Value" },
  { value: "QUANTITY", label: "Quantity" },
];

type NodeComponentFieldTypeRadioProps = {
  name: string;
  isReadOnly?: boolean;
};

export const NodeComponentFieldTypeRadio = ({
  name,
  isReadOnly = false,
}: NodeComponentFieldTypeRadioProps) => (
  <FormRadioGroup
    name={name}
    label="Field type"
    data-testid="formula-component-field-type-radio"
  >
    {NODE_COMPONENT_FIELD_TYPE_OPTIONS.map((option) => (
      <FormRadioButton key={option.value} value={option.value} disabled={isReadOnly}>
        {option.label}
      </FormRadioButton>
    ))}
  </FormRadioGroup>
);
